import { makeAxiosObservable } from "@delanobgt/admin-core/util/epics/AxiosObservable";
import { Epic } from "redux-observable";
import { concat, of, timer } from "rxjs";
import {
  catchError,
  debounceTime,
  filter,
  map,
  switchMap,
  takeUntil,
} from "rxjs/operators";
import Interactors from "src/core/Interactors";
import { RootState } from "src/redux";
import { isActionOf } from "typesafe-actions";

import { actions, TActions } from "./ducks";

export const pollingInvoiceLegitCheckFlow: Epic<
  TActions,
  TActions,
  RootState
> = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(actions.pollingStartRequested)),
    debounceTime(750),
    switchMap(() =>
      timer(0, state$.value.invoiceLegitCheck.refreshDelay).pipe(
        switchMap(() =>
          concat(
            of(actions.fetchAsync.request(null)),
            makeAxiosObservable((signal) =>
              Interactors.invoiceLegitCheck.getInvoiceLegitCheck(
                state$.value.invoiceLegitCheck.pagination,
                state$.value.invoiceLegitCheck.filter,
                state$.value.invoiceLegitCheck.sorts,
                signal
              )
            ).pipe(
              map(([data, meta]) => actions.fetchAsync.success({ data, meta })),
              catchError((error) => of(actions.fetchAsync.failure(error)))
            )
          )
        ),
        takeUntil(
          action$.pipe(filter(isActionOf(actions.pollingStopRequested)))
        )
      )
    )
  );

const invoiceLegitCheckFlows = [pollingInvoiceLegitCheckFlow];

export default invoiceLegitCheckFlows;
